/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentTypeDto } from '../../models/document-type-dto';

export interface DocumentsGetDocumentTypes$Params {
  'x-trace-id'?: string;
}

export function documentsGetDocumentTypes(http: HttpClient, rootUrl: string, params?: DocumentsGetDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, documentsGetDocumentTypes.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentTypeDto>>;
    })
  );
}

documentsGetDocumentTypes.PATH = '/api/documents/types';
